import { STATUSES } from "../../../../enums/AppointmentStatus";
import { REJECT_PENDING } from "../../../../enums/PermissionTitles";

/** Whether the current role may edit, accept or cancel the appointment at all. */
export function canManageAppointment(appointment, roles) {
  if (roles.master) {
    return true;
  } else if (roles.adminOrEmployee) {
    return appointment?.status !== STATUSES.INACTIVE;
  }
  return isAwaitingConfirmation(appointment);
}

/** Whether a pending appointment can be accepted or rejected rather than deleted. */
export function canChangePendingStatus(appointment, isPermissionAllowed) {
  return (
    isPermissionAllowed(REJECT_PENDING) && isAwaitingConfirmation(appointment)
  );
}

function isAwaitingConfirmation(appointment) {
  return (
    appointment?.status === STATUSES.WAITING_CLINIC ||
    appointment?.status === STATUSES.WAITING_USER
  );
}
